// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/flow.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveFlowRequest, ArchiveFlowResponse, CreateFlowRequest, CreateFlowResponse, GetFlowRequest, GetFlowResponse, ListFlowsRequest, ListFlowsResponse, QuickStartFlowRequest, QuickStartFlowResponse, SuggestFlowRequest, SuggestFlowResponse, UpdateFlowRequest, UpdateFlowResponse, ValidateFlowRequest, ValidateFlowResponse } from "./flow_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.FlowService
 */
export const FlowService = {
  typeName: "tracker.v1.FlowService",
  methods: {
    /**
     * @generated from rpc tracker.v1.FlowService.ListFlows
     */
    listFlows: {
      name: "ListFlows",
      I: ListFlowsRequest,
      O: ListFlowsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowService.GetFlow
     */
    getFlow: {
      name: "GetFlow",
      I: GetFlowRequest,
      O: GetFlowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowService.CreateFlow
     */
    createFlow: {
      name: "CreateFlow",
      I: CreateFlowRequest,
      O: CreateFlowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowService.UpdateFlow
     */
    updateFlow: {
      name: "UpdateFlow",
      I: UpdateFlowRequest,
      O: UpdateFlowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.FlowService.ArchiveFlow
     */
    archiveFlow: {
      name: "ArchiveFlow",
      I: ArchiveFlowRequest,
      O: ArchiveFlowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ValidateFlow runs the full save-time validation suite without persisting.
     * Used by the FE editor for live inline error painting on draft change.
     *
     * @generated from rpc tracker.v1.FlowService.ValidateFlow
     */
    validateFlow: {
      name: "ValidateFlow",
      I: ValidateFlowRequest,
      O: ValidateFlowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * QuickStartFlow stamps + persists a simple prelander?->landing->offer
     * starter graph the author then edits freely.
     *
     * @generated from rpc tracker.v1.FlowService.QuickStartFlow
     */
    quickStartFlow: {
      name: "QuickStartFlow",
      I: QuickStartFlowRequest,
      O: QuickStartFlowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AI assistant (OpenRouter connection).
     *
     * @generated from rpc tracker.v1.FlowService.SuggestFlow
     */
    suggestFlow: {
      name: "SuggestFlow",
      I: SuggestFlowRequest,
      O: SuggestFlowResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

